import React, {
  forwardRef, RefObject, useRef, useState,
} from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { SlIcon } from '@sololearnorg/icons';
import { ILeaderboardUser } from '../../../symphony';
import { UserDetailsBadge } from '../UserDetailsBadge/UserDetailsBadge';
import s from './LeaderboardUser.scss';

export interface ILeaderboardUserProps {
  user: ILeaderboardUser;
  isHighlighted?: boolean;
  position: number;
}

export const LeaderboardUser = forwardRef(
  (
    { user, isHighlighted, position }: ILeaderboardUserProps,
    ref: RefObject<HTMLDivElement>,
  ): JSX.Element => {
    useStyles(s);
    const [isValidImage, setIsValidImage] = useState<boolean>(true);

    const highlightedRef = useRef<HTMLDivElement>(null);

    const onImageLoadError = (): void => {
      setIsValidImage(false);
    };

    return user ? (
      <div
        className={`sl-leaderboard-user sl-leaderboard-user ${isHighlighted ? 'highlighter' : ''}`}
        ref={ref}
      >
        <div
          className="sl-leaderboard-user__wrapper"
          ref={highlightedRef}
        >
          <div className="sl-leaderboard-user__left">
            <span className="sl-leaderboard-user__number">
              {position}
            </span>
            <div className="sl-leaderboard-user__avatar">
              {user?.userAvatar && isValidImage ? (
                <img
                  src={user.userAvatar}
                  alt="user-avatar"
                  onError={onImageLoadError}
                />
              ) : (
                <div className="sl-leaderboard-user__avatar--default">
                  <SlIcon iconId="avatarFill" />
                </div>
              )}
            </div>
            <div className="sl-leaderboard-user__name">
              <span>{user.userName}</span>
              <UserDetailsBadge
                badgeString={user.badge}
                mentorLabel="M"
                styles={{
                  mentor: {
                    fontSize: '12px',
                  },
                  subscription: {
                    fontSize: '16px'
                  },
                  experience: {
                    fontSize: '10px'
                  }
                }}
              />
            </div>
          </div>
          <div className="sl-leaderboard-user__xp">
            {user.leaderboardXp}
            {' '}
            XP
          </div>
        </div>
        <hr className="sl-leaderboard-user__breakline" />
      </div>
    ) : null;
  },
);
